import { Link, useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import { useState, useEffect } from "react";
import { addToCart, removeFromCart, getCart } from "../../utils/cartUtils";
import { useAuth } from "../../context/AuthContext";
import { API_BASE } from "../../config/api";

interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  type: string;
}



export default function Header() {
  const [cartOpen, setCartOpen] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [cartProducts, setCartProducts] = useState<Product[]>([]);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
const [menuOpen, setMenuOpen] = useState(false);
  const toggleCart = () => setCartOpen((prev) => !prev);
  const handleOrderClick = () => navigate("/order");

  const refreshCart = () => {
  const storedIds = getCart();
  const selectedProducts = products.filter((p) => storedIds.includes(p.id));
  setCartProducts(selectedProducts);
  const total = selectedProducts.reduce((sum, p) => sum + p.price, 0);
  setTotalPrice(total);
};

  useEffect(() => {
    // Fetch public product list (no auth required)
    fetch(API_BASE + "/api/auth/products", { credentials: "include" })
      .then((res) => res.json())
      .then((data: Product[] | Product) => {
        const products = Array.isArray(data) ? data : [data];
        setProducts(products);
      })
      .catch((err) => console.error("Fehler beim Laden der Produkte", err));
  }, []);

  useEffect(() => {
 refreshCart();
  }, [cartOpen, products]);

  useEffect(() => {
  const handleCartUpdate = () => {
    refreshCart();
  };

  window.addEventListener("cartUpdated", handleCartUpdate);

  return () => {
    window.removeEventListener("cartUpdated", handleCartUpdate);
  };
}, [products]);

  return (
    <>
      <header className={styles.header}>
  <nav className={styles.nav}>

<div className={styles.logo} onClick={() => navigate("/")}>
  <img src="/titlePic.png" alt="RisingDSP" className={styles.logoImg} />
</div>

    {/* BURGER */}
    <div
      className={styles.burger}
      onClick={() => setMenuOpen(!menuOpen)}
    >
      ☰
    </div>

    {/* MENU */}
    <div className={`${styles.navMenu} ${menuOpen ? styles.show : ""}`}>
      <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
    {/* <Link to="/presets" onClick={() => setMenuOpen(false)}>Presets</Link> */}
      {user ? (
        <Link to="/users" onClick={() => setMenuOpen(false)}>
          {user.firstName || "Account"}
        </Link>
      ) : (
        <Link to="/login" onClick={() => setMenuOpen(false)}>
          Account
        </Link>
      )}
    </div>

    {/* RIGHT SIDE */}
    <div className={styles.actions}>
      <button onClick={toggleCart} className={styles.cartButton}>
        🛒
        {cartProducts.length > 0 && (
          <span className={styles.cartBadge}>{cartProducts.length}</span>
        )}
      </button>

      {user && (
        <button
          className={styles.logout}
          onClick={() => {
            logout();
            navigate("/");
          }}
        >
          Logout
        </button>
      )}
    </div>

  </nav>
</header>

      {cartOpen && (
        <div className={styles.cartPanel}>
          <button onClick={toggleCart} className={styles.closeButton}>
            ✕
          </button>
          <h3>Shopping Card</h3>
          {cartProducts.map((p) => (
            <div key={p.id} className={styles.cartItem}>
              <span>{p.name}</span>
              <span>€{p.price.toFixed(2)}</span>
              <button    style={{
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "18px"
  }}className={styles.deleteButton} onClick={() => { removeFromCart(p.id); const ids = getCart(); const sel = products.filter(x=>ids.includes(x.id)); setCartProducts(sel); setTotalPrice(sel.reduce((s, i) => s + i.price, 0)); }}>❌</button>
            </div>
          ))}
          <div>
            <strong>Total: €{totalPrice.toFixed(2)}</strong>
          </div>
          <button onClick={handleOrderClick} className={styles.orderButton}>
           Order now
          </button>
        </div>
      )}
    </>
  );
}